module.exports = __webpack_public_path__ + "media/img/patterns/grid-horizontal-rtl-short-light-8b9066b7b0f02e37bccacde255bab81d.png";